(function () {
  'use strict';

  const selectors = {
    zoomImage: '[data-zoom-image]',
    thumbsTemplate: '[data-zoom-thumbs-template]',
    zoomThumbsContainer: '.pswp__thumbs',
    section: '[data-section-id]',
  };

  // Pointer travel (px) past which a press is treated as a slider drag, not a
  // tap. grid-slider clears its own .is-dragging flag on mouseup — before the
  // click fires — so we can't rely on it and measure movement ourselves.
  const DRAG_THRESHOLD = 10;

  class GalleryZoom extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(selectors.section);
      this.images = this.querySelectorAll(selectors.zoomImage);
    }

    connectedCallback() {
      this.images.forEach((image, index) => {
        let startX = 0;
        let startY = 0;
        let dragged = false;

        image.addEventListener('pointerdown', (event) => {
          startX = event.clientX;
          startY = event.clientY;
          dragged = false;
        });

        image.addEventListener('pointermove', (event) => {
          if (dragged) return;
          if (
            Math.abs(event.clientX - startX) > DRAG_THRESHOLD ||
            Math.abs(event.clientY - startY) > DRAG_THRESHOLD
          ) {
            dragged = true;
          }
        });

        image.addEventListener('click', (event) => {
          event.preventDefault();
          if (dragged) {
            return;
          }
          this.openZoom(index, image);
        });

        image.addEventListener('keyup', (event) => {
          if (event.code !== 'Enter') {
            return;
          }
          event.preventDefault();
          this.openZoom(index, image);
        });
      });
    }

    openZoom(index, image) {
      this.createZoom(index);
      if (window.a11y) {
        window.a11y.lastElement = image;
      }
    }

    createZoom(startIndex) {
      const items = [];

      this.images.forEach((image) => {
        const src = image.getAttribute('data-image-src');
        items.push({
          src: src,
          msrc: src,
          w: parseInt(image.getAttribute('data-image-width'), 10),
          h: parseInt(image.getAttribute('data-image-height'), 10),
        });
      });

      const colorScheme = this.getColorScheme();
      const options = {
        history: false,
        focus: false,
        index: startIndex,
        mainClass: `pswp-zoom-gallery${items.length === 1 ? ' pswp-zoom-gallery--single' : ''}${
          colorScheme ? ` ${colorScheme}` : ''
        }`,
        showHideOpacity: true,
        showAnimationDuration: 150,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: true,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['title'],
        tapToClose: true,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
        getThumbBoundsFn: (index) => {
          const thumb = this.images[index];
          if (!thumb) return null;
          const pageYScroll = window.scrollY || document.documentElement.scrollTop;
          const rect = thumb.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      };

      new window.theme.LoadPhotoswipe(items, options);

      const thumbsContainer = document.querySelector(selectors.zoomThumbsContainer);
      const thumbsTemplate = this.section?.querySelector(selectors.thumbsTemplate)?.innerHTML;
      if (thumbsContainer && thumbsTemplate) {
        thumbsContainer.innerHTML = thumbsTemplate;
      }
    }

    getColorScheme() {
      if (!this.section) {
        return '';
      }
      return Array.from(this.section.classList).find((cls) => cls.startsWith('color-')) || '';
    }
  }

  if (!customElements.get('gallery-zoom')) {
    customElements.define('gallery-zoom', GalleryZoom);
  }
})();
